import DirectionsCarFilled from '@mui/icons-material/DirectionsCarFilled';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class CarBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Car;

  get Icon(): React.ComponentType<SvgIconProps> {
    return DirectionsCarFilled;
  }
}
